import './styles/index.less'
import {createRoot} from 'react-dom/client'
import {RouterProvider} from 'react-router'
import {ConfigProvider} from 'antd'
import {ANTD_THEME} from '@eitje/web_components'
import {NotificationProvider, NotificationsContainer} from '~/components'
import {PageSpinner} from './components'
import {router} from '~/routing'
import {store, persistor, StoreProvider} from '~/store'
import '~/initializers'

const modalConfig = {
	mask: {
		blur: false,
	},
}

createRoot(document.getElementById('root')).render(
	<ConfigProvider theme={ANTD_THEME} modal={modalConfig}>
		<StoreProvider store={store} persistor={persistor}>
			<NotificationProvider>
				<NotificationsContainer />
				<PageSpinner>
					<RouterProvider router={router} />
				</PageSpinner>
			</NotificationProvider>
		</StoreProvider>
	</ConfigProvider>,
)
